import FormData from "form-data";
import { useApiReload } from "../context/apiRelaod";
import { CaseAdd } from "./apiService";

const useAddNote = () => {
    const { call } = CaseAdd();
    const { setReloadPatient } = useApiReload();

    const addNote = (data: any) => {
        const { patientId, caseId, noteType, file } = data;
        const formData = getFormData(patientId, caseId, noteType, file);
        if(patientId === 'Anonymous') setReloadPatient(true);
        return call(formData);
    };
    return { addNote };
};

const getFormData = (
    patientId: string,
    caseId: string,
    noteType: string,
    file: File
): FormData => {
    const formData = new FormData();
    formData.append('audioUrl', file);
    formData.append('noteType', noteType ?? 'INITIAL_NOTE');
    if (patientId === 'Anonymous')
        return formData;
    formData.append('patientId', patientId);
    if (caseId && caseId !== "-1") formData.append('caseId', caseId);
        return formData;
}

export { useAddNote as default, getFormData };
